module.exports = __webpack_public_path__ + "static/img/s1.8c8d610.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/social/s1.jpg
// module id = sj57
// module chunks = 0